import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { FolderItem } from "~/client/components/items/FolderItem";
import { useFolders } from "~/client/services/data/folders/hooks";
interface WorkspaceFoldersProps {
  readonly folderId?: string;
}
export const WorkspaceFolders: FC<WorkspaceFoldersProps> = t0 => {
  const $ = _c(6);
  const {
    folderId: t1
  } = t0;
  const folderId = t1 === undefined ? null : t1;
  let t2;
  if ($[0] !== folderId) {
    t2 = {
      folderId
    };
    $[0] = folderId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data: folders
  } = useFolders(t2);
  let t3;
  if ($[2] !== folders) {
    t3 = folders.map(_temp);
    $[2] = folders;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="workspace__folders">{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export const WorkspaceFoldersFallback = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="workspace__folders" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(f) {
  return <FolderItem key={f.id} folder={f} />;
}